import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Success = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-lg mx-auto px-4">
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <div className="flex justify-center mb-6">
              <div className="h-16 w-16 bg-ta-green/10 rounded-full flex items-center justify-center">
                <CheckCircle className="h-10 w-10 text-ta-green" />
              </div>
            </div>
            
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              {t('success.title')}
            </h1>
            
            <p className="text-gray-600 mb-6">
              {t('success.message')}
            </p>
            
            <Link 
              to="/"
              className="inline-flex items-center text-ta-green hover:text-ta-green-dark"
            >
              <ArrowLeft className="h-4 w-4 mr-1" />
              {t('success.returnHome')}
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Success;